import type { Requests } from "../common/request.common";
import type { SystemDisbursementResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const systemDisbursement = {
    record(data: typeof Requests.SystemDisbursement.Record.Input) {
        return post<typeof data, SystemDisbursementResponseTypes.Record>(
            `/system-disbursement/record`,
            data,
        );
    },
    balance() {
        return get<SystemDisbursementResponseTypes.Balance>(`/system-disbursement/balance`);
    },
    create(data: typeof Requests.SystemDisbursement.Create.Input) {
        return post<typeof data>(`/system-disbursement/create`, data);
    },
    obtain(id: string) {
        return get<SystemDisbursementResponseTypes.Obtain>(`/system-disbursement/obtain/${id}`);
    },
    calculateFee(data: typeof Requests.SystemDisbursement.CalculateFee.Input) {
        return post<typeof data, SystemDisbursementResponseTypes.CalculateFee>(
            `/system-disbursement/calculate-fee`,
            data,
        );
    },
};
